// src/pages/Legal.js
// Renders the legal documents (ported from the mobile app). `doc` selects one;
// when it's missing/"index" it shows a menu of all policies.

import { LEGAL_DOCS, LEGAL_ORDER, LEGAL_EMAIL } from "../data/legalContent";

const LABELS = {
  terms: "Terms of Use",
  privacy: "Privacy Policy",
  eula: "End User License Agreement",
  "content-policy": "Content Policy",
  refund: "Refund & Cancellation",
};

function Email() {
  return <a className="legal__email" href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>;
}

function Section({ s }) {
  return (
    <>
      <h2 className="legal__h">{s.h}</h2>
      {(s.p || []).map((t, i) => <p key={i} className="legal__p">{t}</p>)}
      {s.ul && (
        <ul className="legal__ul">
          {s.ul.map((t, i) => <li key={i}>{t}</li>)}
        </ul>
      )}
      {(s.pAfter || []).map((t, i) => <p key={i} className="legal__p">{t}</p>)}
      {s.email && <Email />}
    </>
  );
}

export default function Legal({ doc, onOpen, onBack }) {
  // Index / menu
  if (!doc || doc === "index" || !LEGAL_DOCS[doc]) {
    return (
      <div className="page" style={{ maxWidth: 640 }}>
        <div className="page__head">
          <h1>Legal &amp; policies</h1>
          <p className="page__sub">The terms that govern your use of KarviAI.</p>
        </div>
        <div className="legal__menu">
          {LEGAL_ORDER.map((key) => (
            <button key={key} className="legal__menu-item" onClick={() => onOpen(key)}>
              <span>{LABELS[key]}</span>
              <span aria-hidden="true">›</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  const d = LEGAL_DOCS[doc];
  return (
    <div className="page" style={{ maxWidth: 720 }}>
      <button className="iconbtn" onClick={onBack} aria-label="Back" style={{ marginBottom: 16 }}>←</button>
      <div className="legal">
        <h1 className="legal__title">{d.title}</h1>
        {(d.intro || []).map((t, i) => <p key={i} className="legal__p">{t}</p>)}

        {d.box && (
          <div className={`legal__box legal__box--${d.box.type}`}>
            <span aria-hidden="true">{d.box.type === "warning" ? "⚠️" : "ℹ️"}</span>
            <span>{d.box.text}</span>
          </div>
        )}

        {d.sections.map((s, i) => <Section key={i} s={s} />)}

        <div className="legal__nav">
          {LEGAL_ORDER.filter((k) => k !== doc).map((k) => (
            <button key={k} className="legal__chip" onClick={() => onOpen(k)}>{LABELS[k]}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
